import { useEffect, useRef } from 'react';

import type { SelectableProperty } from '../SearchPerformanceProperties';
import useTrackSearchPerformanceEvent from '../useTrackSearchPerformanceEvent';
import type { PagesTabKey } from './PagesTabs';

export function useTrackPagesTabViewed(tab: PagesTabKey, selectedProperty: SelectableProperty | undefined): void {
  const trackEvent = useTrackSearchPerformanceEvent();
  const viewedTabRef = useRef<PagesTabKey | undefined>(undefined);
  useEffect(() => {
    if (!selectedProperty || viewedTabRef.current === tab) {
      return;
    }
    viewedTabRef.current = tab;
    trackEvent('Search Performance: Pages Tab Viewed', { tab });
  }, [tab, selectedProperty, trackEvent]);
}
